import { setShiOneIdentity, clearShiOneIdentity, isEmittingEnvironment } from "shared-ui/src/instrumentation/gtm";
import { isEmbeddedMode } from "../utils/embeddedMode";
import { TelemetryUser } from "./telemetryUser";

/**
 * GTM telemetry provider. Only non-PII, opaque ids are forwarded as GA4 User
 * Properties - email, name, and account name are excluded.
 *
 * Page views and actions are not emitted by the app at all: GA4 gets page views from
 * Enhanced Measurement automatically, and actions from the existing `telemetry_click`
 * event.
 *
 * Suppressed entirely when CX is running embedded inside the Customer Success iframe,
 * so identity pushed here doesn't reflect a mismatched embedding context.
 */
export class GtmTelemetry {
  init = () => {};

  trackException = () => {};

  beginUser = (user: TelemetryUser) => {
    if (isEmbeddedMode()) return;
    setShiOneIdentity({
      userId: user.userId ?? undefined,
      employeeId: user.employeeId ?? undefined,
      isImpersonating: user.impersonatedBy !== null,
      impersonatorId: user.impersonatedBy ?? undefined,
      isVirtualAdmin: user.isVirtualAdmin,
      tenantId: user.tenantId ?? undefined,
      accountGroupId: user.accountGroupId ?? undefined,
      storefrontId: user.storefrontId ?? undefined,
      isGuestUser: user.isGuestUser,
      salesOrg: user.salesOrg ?? undefined,
      isComplete: user.isIdentityComplete,
    });
  };

  endUser = () => {
    if (isEmbeddedMode()) return;
    clearShiOneIdentity();
  };
}

export const gtmTelemetry = isEmittingEnvironment(import.meta.env.DIST_ENV) ? new GtmTelemetry() : null;
